module.exports = __webpack_public_path__ + "media/video_bg_1.cc724aa9.mp4";